// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__26sC0","colCheckbox":"styles_colCheckbox__21vpW"};